const inicialState = {
  imunologiaFinalizada: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/imuno/imuno.state.js